document.addEventListener("DOMContentLoaded", function () {
    function geturlLang() {
        return window.location.pathname.includes("/es/") ? "es" : "en";
    }

    function toggleLanguageText() {
        const spanishEl = document.querySelector(
            '.appstle_subscription_wrapper .appstle_subscription_wrapper_option .appstle_subscribe_option #translate_wrapper #spanish'
        );
        const englishEl = document.querySelector(
            '.appstle_subscription_wrapper .appstle_subscription_wrapper_option .appstle_subscribe_option #translate_wrapper #english'
        );

        if (spanishEl && englishEl) {
            if (geturlLang() === 'en') {
                spanishEl.style.display = 'none';
                englishEl.style.display = 'block';
            } else {
                spanishEl.style.display = 'block';
                englishEl.style.display = 'none';
            }
        }
    }

    toggleLanguageText();

    const observer = new MutationObserver(() => {
        toggleLanguageText();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
